import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  fill: "none",
  viewBox: "0 0 15.071 14.443"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF6B6B",
  d: "M6.901 7.333H4.38l1.758 7.11H2.553L.796 7.333H0V0h6.901v7.333ZM15.07 7.333h-2.522l1.758 7.11h-3.583l-1.758-7.11h-.796V0h6.901v7.333Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }